import { Button, Card, Icon, Popover } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { SCALAR_TYPES, VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ContactFormField, ContactFormFields } from "../../data/interfaces"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import FieldInput from "src/libs/scalars"
import { __, getID } from "src/libs/utilities"
import { OVERLAY2_DEFAULT_PROPS } from "@blueprintjs/core/lib/esm/components/overlay2/overlay2"


export const CONTACT_FORM_FIELDS ={
    [SCALAR_TYPES.STRING] : {
        id: SCALAR_TYPES.STRING
    },
    [SCALAR_TYPES.HTML] : {
        id: SCALAR_TYPES.HTML
    },
    [SCALAR_TYPES.NUMBER] : {
        id: SCALAR_TYPES.NUMBER
    },
    [SCALAR_TYPES.SLIDER] : {
        id: SCALAR_TYPES.SLIDER
    },
    [SCALAR_TYPES.MEDIA] : {
        id: SCALAR_TYPES.MEDIA
    },
    [SCALAR_TYPES.DATA_TYPE] : {
        id: SCALAR_TYPES.DATA_TYPE
    },
    [SCALAR_TYPES.CHECKBOX] : {
        id: SCALAR_TYPES.CHECKBOX
    }, 
} 
/* Protopia Ecosystem component */
export interface IFieldInputScalarProps extends ICompositeWidgetProps  {
   
}
const FieldInputScalar = (props: IFieldInputScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            subtitle={props.title}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <FieldInputScalarEnabled {...props} /> }  
            desabledForm={ <FieldInputScalarDisable {...props} /> }   
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}
export default FieldInputScalar

const FieldInputScalarEnabled = (props: IFieldInputScalarProps): JSX.Element => {
    const [value, setValue] = useState<ContactFormFields>( props.value || props.default || {})

    useEffect(() => {
        setValue( props.value )
    }, [ props.value ])

    const onChange = (_value: any, field: string, dop: any) => {
        const newValue = {
            ...value,
            [field]: _value
        }
        onFinalChange(newValue)
    }
    const onAdd = ( ) => {
        const newValue: any = {
            ...value,
            [ getID("cf") ]: { type: SCALAR_TYPES.STRING, value: "" }
        }
        onFinalChange(newValue) 
    }
    const onDelete = ( key: string ) => {
        const newValue = {...value}
        delete( newValue[key] )
        onFinalChange(newValue) 
    }
    const onDuplicate = ( key: string ) => {
        const newValue = { 
            ...value, 
            [ getID("cf") ]: {...value[key]} 
        }        
        onFinalChange(newValue) 
    }
    const onFinalChange = (newValue: ContactFormFields) => {
        if(props.onChange) {
            props.onChange( newValue, props.field, "" )
        }
    }
    return <div className="w-100 pl-1 pr-4 mr-2 d-flex flex-column flex-wrap"> 
        {
            Object.keys(value).map(key => {
                return <SingleFieldInputForm value={value[key]}  field={key} key={key} onChange={onChange} onDelete={ ()=> onDelete(key) }  onDuplicate={ ()=> onDuplicate(key) } />
            })
        }
        <Button className="btn-stretch p-2" variant="minimal" fill onClick={onAdd}>
        <div className="square2-- flex-centered">
            <Icon icon="plus" />
        </div>
    </Button>
    </div>
}

export interface ISingleFieldInputForm {
    value: ContactFormField
}
const SingleFieldInputForm = ({value, field, onChange, onDelete, onDuplicate}:any): JSX.Element => {
    const onValueChange = (_value: any, _field: string, dop: any) => {
        onChange(
            {
                ...value,
                [_field]: _value
            },
            field
        )
    }
    return <Popover
    interactionKind="hover"
        position="left"
        content={
            <div className="py-3 pl-4">
                <div className="strob01">
                    <FieldInput
                        subtitle="type"
                        field="type"
                        type={ SCALAR_TYPES.SELECT }
                        values={ Object.keys(CONTACT_FORM_FIELDS).map(key => ({
                            _id: key,
                            title: __(key)
                        })) }
                        editable
                        value={ value.type }
                        onChange={onValueChange}
                    />
                </div>
                <div className="strob01">
                    <FieldInput
                        subtitle="Field visual title"
                        field="subtitle"
                        type={ SCALAR_TYPES.STRING } 
                        editable
                        value={ value.subtitle }
                        onChange={onValueChange}
                    />
                </div>
                <div className="strob01">
                    <FieldInput
                        subtitle="Field name"
                        field="field"
                        type={ SCALAR_TYPES.STRING } 
                        editable
                        value={ value.field || getID("cf")}
                        onChange={onValueChange}
                    />
                </div>
                <div className="strob01">
                    <FieldInput
                        subtitle="Field commentary"
                        field="commentary"
                        type={ SCALAR_TYPES.HTML } 
                        rows={4}
                        editable
                        value={ value.commentary }
                        onChange={onValueChange}
                    />
                </div>
                <div className="strob01">
                    <FieldInput
                        subtitle="Is require field&"
                        field="require"
                        type={ SCALAR_TYPES.BOOLEAN } 
                        editable
                        value={ value.require }
                        onChange={onValueChange}
                    />
                </div>
            </div>
        }
    >
        <Button className="btn-stretch p-2 mb-1" variant="outlined" alignText="left"  fill>
            <div className="w-100 d-flex align-items-center justify-content-between smaller text-wrap text-uppercase letter-spacing-0">
                <div>
                    { __(value.type) }
                </div>
                <span>
                    <Button size="small" variant="minimal" icon="duplicate" className="pe-surface3" onClick={onDuplicate} />
                    <Button size="small" variant="minimal" icon="trash" className="pe-surface3" onClick={onDelete} />
                </span>
            </div>
        </Button>
    </Popover> 
}

const FieldInputScalarDisable = (props: IFieldInputScalarProps): JSX.Element => {
    return <></>
}